'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { TargetSelectPage } from '../-components/TargetSelectPage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/certificate-issuance/targets/')({
  component: TargetSelectPage
});